import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {SavedViewsResponse} from '@github-ui/saved-views'
import {fetchSavedViews} from '@github-ui/saved-views/queries'

import {repoAppBuilder} from '@github-ui/repo-app-builder'

export function buildSavedViewsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('savedViewsRoute', {
    path: '/:owner/:repo/issues/views',
    queries: [
      // eslint-disable-next-line @github-ui/github-monorepo/require-query-schema -- The existing views.json endpoint returns plain JSON, not a Protobuf payload.
      mainQuery<SavedViewsResponse>({
        queryDeps: ({pathname}) => {
          const [, owner, repo] = pathname.split('/')
          return {pathname: `/${owner}/${repo}/issues/views.json`}
        },
        queryFn: async ({queryDeps}, {signal}) => {
          const [, owner = '', repo = ''] = queryDeps.pathname.split('/')
          const payload = await fetchSavedViews({owner, repo, signal})
          return {meta: {}, payload} as unknown as SavedViewsResponse
        },
      }),
    ],
  })
}

export function buildSavedViewNewRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('savedViewNewRoute', {
    path: '/:owner/:repo/issues/views/new',
    queries: [],
  })
}

export function buildSavedViewRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('savedViewRoute', {
    path: '/:owner/:repo/issues/views/:id',
    queries: [],
  })
}

export const savedViewsRoute = buildSavedViewsRoute(repoAppBuilder)
export const savedViewNewRoute = buildSavedViewNewRoute(repoAppBuilder)
export const savedViewRoute = buildSavedViewRoute(repoAppBuilder)
